import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageSquare, FiStar, FiQuote } = FiIcons;

const Testimonials = ({ viewMode }) => {
  const professionalTestimonials = [
    {
      name: "Michael R. O'Brien",
      role: "CFO",
      content: "Gary is a business-centric, results-oriented individual who did a terrific job managing all IT functions. He has a tremendous ability to diagnose and optimize problems while keeping a strategic perspective for the company.",
      rating: 5
    },
    {
      name: "John Avellar",
      role: "Managing Consultant | CISSP, CISM",
      content: "Gary works hard to develop talent by advocating for tools and training. He provides clear direction and candid feedback, creating trust and integrity. He possesses a wealth of IT knowledge and exceptional troubleshooting skills.",
      rating: 5
    },
    {
      name: "Donald Wright",
      role: "Technology Consultant | VP",
      content: "Gary breaks the mold by conducting IT operations that cater to the needs of the business, rather than the needs of IT. He inspires teams toward efficiency and effectiveness while remaining incredibly approachable.",
      rating: 5
    },
    {
      name: "Ann Goldman",
      role: "Seasoned Executive",
      content: "Gary is terrific at troubleshooting problems with little direction. He's extremely responsive and maintains a terrific attitude regarding work, even under great pressure—a sign of a truly great sys admin.",
      rating: 5
    },
    {
      name: "Dale Skinner",
      role: "IT Consultant, Milliman",
      content: "An excellent system administrator. Gary always responds promptly to issues, resolves problems in a timely manner, and is always friendly when interacting with people.",
      rating: 5
    }
  ];

  const personalTestimonials = [
    {
      name: "Mark Thompson",
      role: "Mentorship Community Member",
      content: "Gary doesn't just share knowledge; he shares wisdom. He's helped me bridge the gap between knowing what to do and actually having the will to take action.",
      rating: 5
    },
    {
      name: "Elena Rossi",
      role: "BJJ Training Partner",
      content: "On the mats, Gary shows the same discipline he brings to engineering. He's a dedicated mentor who leads by example for his family and his community.",
      rating: 5
    },
    {
      name: "Robert Wilson",
      role: "Church Ministry Lead",
      content: "His ability to explain complex concepts using simple language is a gift. The 2nd graders love his lessons, and so do the parents.",
      rating: 5
    }
  ];

  const currentTestimonials = viewMode === 'professional' ? professionalTestimonials : personalTestimonials;

  return (
    <section className="section-padding bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center space-x-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-bold mb-4"
          >
            <SafeIcon icon={FiMessageSquare} className="w-4 h-4" />
            <span>Success Stories</span>
          </motion.div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {viewMode === 'professional' ? 'Professional Endorsements' : 'Community Voices'}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {viewMode === 'professional' 
              ? "Reflections from executives and team members on three decades of IT leadership." 
              : "Reflections from my community, mentorship, and martial arts journey."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {currentTestimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 relative flex flex-col h-full"
            >
              <div className="absolute top-6 right-8 opacity-10">
                <SafeIcon icon={FiQuote} className="w-12 h-12 text-teal-600" />
              </div>
              
              <div className="flex space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                ))}
              </div>

              <p className="text-gray-700 text-lg mb-8 italic leading-relaxed flex-grow">
                "{testimonial.content}"
              </p>

              <div className="flex items-center mt-auto pt-6 border-t border-gray-50">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4 shadow-lg flex-shrink-0">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 leading-tight">{testimonial.name}</h4>
                  <p className="text-sm text-teal-600 font-medium">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;